<template>
    <div>
        <router-view name="demandModal"></router-view>
        <v-card>
            <v-tabs v-model="activeTab" vertical>
                <v-tab v-for="tab of tabs" :key="tab.id" :to="tab.route" exact>
                    <v-icon left>{{ tab.icon}}</v-icon>
                    {{ tab.name }}
                </v-tab>

                <v-tabs-items v-model="activeTab">
                    <router-view></router-view>
                </v-tabs-items>
            </v-tabs>
        </v-card>
    </div>
</template>

<script>
export default {
    name: 'detail-staff',
    metaInfo () {
        return {
            title: this.$t('legalTeam.detail.meta.title'),
            meta: [
                { name: 'description', content: this.$t('legalTeam.detail.meta.description') },
                { name: 'keywords', content: this.$t('legalTeam.detail.meta.keywords') }
            ]
        }
    },
    props: ['id'],
    data: function () {
        return {
            activeTab: `/juridico/detalhe/${this.id}`,
            tabs: [
                { id: 1, icon: 'person', name: this.$t('legalTeam.detail.tabs.legalTeam'), route: `/juridico/detalhe/${this.id}` },
                { id: 2, icon: 'gavel', name: this.$t('legalTeam.detail.tabs.demands'), route: `/juridico/detalhe/${this.id}/demandas/ativas` },
                { id: 3, icon: 'list', name: this.$t('legalTeam.detail.tabs.timeline'), route: `/juridico/detalhe/${this.id}/timeline` }
            ]
        }
    }
}
</script>
